<template>
  <div class="fullscreenPanel">
    <p class="fullscreenPanel-text">
      <slot />
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.fullscreenPanel {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(45deg, #{$green}, #3891a6);
  color: white;
}
.fullscreenPanel-text {
  @include use-title-font;
  text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
}
</style>
